<template>
    <div class="sidebar shadow rounded bg-light d-flex flex-column">
        <div>
            <b-img fluid rounded src="https://weihuaxiaozhan.oss-cn-hongkong.aliyuncs.com/assets/avatar.jpg" alt="Image 1"></b-img>
        </div>
        <div class="container fluid mt-3">
            <div class="row">
                <div class="col">
                    <b-img rounded src="https://weihuaxiaozhan.oss-cn-hongkong.aliyuncs.com/assets/weiboicon.png" alt="Image 1" style="width:40px;height:40px"></b-img>
                </div>
                <div class="col">
                    <b-img rounded src="https://weihuaxiaozhan.oss-cn-hongkong.aliyuncs.com/assets/weixinicon.png" alt="Image 1" style="width:40px;height:40px"></b-img>
                </div>
                <div class="col">
                    <b-img rounded src="https://weihuaxiaozhan.oss-cn-hongkong.aliyuncs.com/assets/qqicon.png" alt="Image 1" style="width:40px;height:40px"></b-img>
                </div>
            </div>
        </div>
        <div class="container fluid mt-3 category-container">
            <b-button size="sm" v-bind:class="visibleOfCategory ? null : 'collapsed'" 
                v-bind:aria-expanded="visibleOfCategory ? 'true' : 'false'"
                aria-controls="collapse-category"
                variant="outline-primary"
                v-on:click="visibleOfCategory = !visibleOfCategory">
                所有标签 <b-icon v-bind:icon="visibleOfCategory ? 'caret-up-fill' : 'caret-down-fill'" variant=""></b-icon>
            </b-button>
            <b-collapse id="collapse-category" v-model="visibleOfCategory" class="mt-2">
                <CategoryItem v-for="(item) in categories" v-bind:key="item.name" v-bind:name="item.name"/>
            </b-collapse>
        </div>
        <div class="container fluid mt-3">
            <b-button size="sm" v-bind:class="visibleOfThirdLink ? null : 'collapsed'" 
                v-bind:aria-expanded="visibleOfThirdLink ? 'true' : 'false'"
                aria-controls="collapse-third"
                variant="outline-primary"
                v-on:click="visibleOfThirdLink = !visibleOfThirdLink">
                其他技术博客 <b-icon v-bind:icon="visibleOfThirdLink ? 'caret-up-fill' : 'caret-down-fill'" variant=""></b-icon>
            </b-button>
            <b-collapse id="collapse-third" v-model="visibleOfThirdLink" class="mt-2">
                <b-list-group>
                    <b-list-group-item class="thirdlink-item" href="https://tech.meituan.com" target="_blank" variant="light">美团技术博客</b-list-group-item>
                    <b-list-group-item class="thirdlink-item" href="https://www.zhihu.com/org/a-li-yun-yun-qi-she-qu-48/posts" target="_blank" variant="light">知乎·阿里云栖</b-list-group-item>
                </b-list-group>
            </b-collapse>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import CategoryItem from '../components/CategoryItem'
import axios from 'axios'
// import GlobalConstant from '../constants/GlobalConstant'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
    name : 'SideBar',
    props: {

    },
    components: {
        CategoryItem
    },
    data: function(){
        return {
            visibleOfThirdLink : false,
            visibleOfCategory : true,
            categories : []
        }
    },
    mounted: function(){
        this.setCategoryData();
    },
    methods : {
        setCategoryData : function(){
            var _this = this;
            var categoryData = [];
            var allCate = {};
            //allCate.id=0;
            allCate.name = '全部';
            categoryData.push(allCate);

            axios.get('/api/category/listAll')
                .then(function(response){
                    console.log(response)
                    var res = response.data;
                    if(res.code == 1){
                        var data = res.data;
                        if(data){
                            data.forEach(element => {
                                var obj = {};
                                //obj.id = element.id;
                                obj.name = element.name
                                categoryData.push(obj);
                            });
                        }
                        _this.$set(_this, "categories", categoryData);
                    }else{
                        console.log(res.msg);
                    }
                }).catch(function(error){
                    console.log(error)
                })


            // var categoryData = [
            //     {id:1, name:"标签1"},
            //     {id:2, name:"标签21231"},
            //     {id:3, name:"标我加上签21231"}
            // ];
            
        }
    }
}
</script>

<style>
    .sidebar{
        height: 880px;
        padding: 10px;
    }
    .item{
        height: 200px;
        /* background-color:floralwhite; */
    }
    .category-container{
        max-height: 200px;
    }
    .thirdlink-item{
        font-size: 0.5em !important;
    }
</style>